import { useEffect } from 'react';

import SuccessIcon from 'assets/icons/base/success-icon.svg';
import { useAmount, useMainNavigate, useTranslate, useYM } from 'hooks';
import { useAppSelector } from 'store/hooks';
import { ButtonKinds } from 'types/button';
import { PaymentWrapper } from 'views/components/base/payment-wrapper';
import { Button } from 'views/components/base/ui';
import { SendCheck } from 'views/forms/base/send-check';

const PaymentSuccess = () => {
  const { paymentData, isPayment } = useAppSelector((state) => state.payment);
  const { formattedAmount } = useAmount();
  const { goToReturnUrl } = useMainNavigate();
  const { t } = useTranslate();
  const { trackOnClick } = useYM();

  useEffect(() => {
    trackOnClick('openSuccessForm');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <PaymentWrapper className="bg-base-green-200 flex items-center w-full md:w-auto flex-col">
      <div className="text-white flex flex-col text-center flex-grow mx-auto md:w-full md:text-left gap-12 md:justify-center md:gap-9 h-full">
        <div>
          <div className="block md:hidden mx-auto mb-4">
            <img src={SuccessIcon} className="mx-auto" alt="success" />
          </div>
          <div>
            <h3 className="text-xl leading-6 font-bold">
              {isPayment ? t('kase.pay_successful') : t('lang.payout_successful')}
            </h3>
          </div>
          <div className="block md:hidden mt-4 text-base leading-6 font-semibold">
            {paymentData?.description}
          </div>
        </div>
        <div>
          <dl className="mb-4 last:mb-0">
            <dt className="uppercase text-sm md:text-[10px] font-semibold md:font-normal leading-3 tracking-[2px] mb-2 opacity-60">
              {t('amount')}
            </dt>
            <dd className="text-2xl md:text-base leading-5 font-bold">{formattedAmount}</dd>
          </dl>
        </div>
        <div>
          <SendCheck />

          {paymentData?.returnURL && (
            <Button
              className="md:max-w-[270px] mt-2"
              kind={ButtonKinds.secondary}
              onClick={() => goToReturnUrl(paymentData?.returnURL)}
            >
              {t('kase.btn.return_to_store')}
            </Button>
          )}
        </div>
      </div>
    </PaymentWrapper>
  );
};

export { PaymentSuccess };
